import { render, staticRenderFns } from "./StoreCommentLists.vue?vue&type=template&id=c79f958a&scoped=true"
import script from "./StoreCommentLists.vue?vue&type=script&lang=js"
export * from "./StoreCommentLists.vue?vue&type=script&lang=js"
import style0 from "./StoreCommentLists.vue?vue&type=style&index=0&id=c79f958a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f958a",
  null
  
)

export default component.exports